// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"106":"music","162":"films","337":"Contact","348":"food","819":"web"}[chunkId] + "." + {"106":"6b472e6d","162":"98933388","337":"b956db14","348":"3d92ff27","819":"2fa7a2fa"}[chunkId] + ".js";
};